import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import DoneIcon from '@material-ui/icons/Done';


var classNames = require('classnames');


const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    colorChoice: {

        height: '28px',
        width: '28px',
        borderRadius: '50%',
        margin: '9px',
        boxShadow: '0 0 2px rgba(0,0,0,.12), 0 2px 2px rgba(0, 0, 0, .24)',
        position: 'relative',
        cursor: 'pointer',
        transition: 'transform .15s ease',

        '&:hover': {
            transform: 'scale(1.15)',
            transition:'transform .15s ease'
        },


        '& .dicon': {
            position: 'absolute',
            color:'#fff',
            top: '2px',
            left: '2px'
        },


        '&.black': { backgroundColor: '#000' },
        '&.dblue': { backgroundColor: '#00008b' },
        '&.lblue': { backgroundColor: '#add8e6' },
        '&.brown': { backgroundColor: '#A0522D' },        
        '&.gray': { backgroundColor: '#808080' },
        '&.gold': { backgroundColor: '#FFD700' },
        '&.green': { backgroundColor: '#008000' },
        '&.maroon': { backgroundColor: '#800000' },
        '&.red': { backgroundColor: '#FF0000' },
        '&.orange': { backgroundColor: '#FFA500' },
        '&.purple': { backgroundColor: '#800080' },
        '&.silver': { backgroundColor: '#C0C0C0', '& .dicon': { color: '#000' } },
        '&.tan': { backgroundColor: '#D2B48C' },
        '&.white': {
            backgroundColor: '#fff', '& .dicon': {color:'#000'} },
        '&.yellow': { backgroundColor: '#FFFF00', '& .dicon': { color: '#000' } },

        '&.selected': {  
            transform: 'scale(1.3)',
            transition: 'transform .15s ease'
        }
    }

});


export class ColorPicker extends Component {
    state = {
       
    };
    onChange(color) {       
        this.props.onChange(color);       
    }
    render() {
        const { classes } = this.props;        
        return (
            <div>                
            <div className={classes.root}>
            {
                this.props.colors.map(color => {

                    var css = classNames([
                        classes.colorChoice,
                        color.id,
                        { 'selected': color.id === this.props.selectedColor.id }
                    ]);                        
                            return (<div key={color.id} className={css} onClick={() => { this.onChange(color); }}>
                            {
                                    color.id === this.props.selectedColor.id && <span className="dicon"><DoneIcon /></span>
                            }
                        </div>);
                })
            }
                </div>
                </div>
        );
    }
}

ColorPicker.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ColorPicker);


// WEBPACK FOOTER //
// ./src/components/ColorPicker.jsx